import Money from "dinero.js";
Money.defaultCurrency = "BRL";
Money.globalLocale = "pt-BR";
Money.defaultPrecision = 2;

export default Money;
